const EU_COUNTRY_CODES = [
	'AT',
	'BE',
	'BG',
	'CY',
	'CZ',
	'DE',
	'DK',
	'EE',
	'EL',
	'ES',
	'FI',
	'FR',
	'HR',
	'HU',
	'IE',
	'IT',
	'LT',
	'LU',
	'LV',
	'MT',
	'NL',
	'PL',
	'PT',
	'RO',
	'SE',
	'SI',
	'SK',
	'UK',
];

// eslint-disable-next-line no-unused-vars
export const getBreakpoint = () => {
	return window
		.getComputedStyle(document.querySelector('html'), ':before')
		.getPropertyValue('content')
		.replace(/\"/g, '');
};

export const checkTouchSupport = function () {
	return (
		'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0
	);
};

export const getRTL = () => {
	return /ar/.test(document.documentElement.lang);
};

/**
 * Checks for a given CSS feature
 * @param  {String} tag     	The tag over which to
 * @param  {String} feature 	The name of the rule to test
 * @return {boolean}          True if the feature is supported
 */
export function testCSSFeature(tag, feature) {
	const prefixes = ['', '-webkit-', '-moz', '-ms', '-webkit-', '-o-'];
	let hasFeature = false;
	const element = document.createElement(tag);
	for (const prefix of prefixes) {
		if (element.style.hasOwnProperty(prefix + feature)) {
			hasFeature = true;
			break;
		}
	}
	return hasFeature;
}

/**
 * Simple polyfill for IE11
 */
export function locationOriginPolyfill() {
	if (!window.location.origin) {
		window.location.origin =
			window.location.protocol +
			'//' +
			window.location.hostname +
			(window.location.port ? ':' + window.location.port : '');
	}
}

/**
 * Returns the Country code provided by the GeoIPCookie
 * Value is formatted as 'GEOIP_COUNTRY_CODE=CN'
 * @return {string|undefined} The value of the cookie if it exists
 */
export function getGeoIPCountryCode() {
	// If cookie does not exist in page, return immediately
	if (document.cookie.indexOf('GeoIPCookie') === -1) {
		return;
	}

	// Retrieve value of 'GeoIPCookie' cookie
	let region = document.cookie.match('GeoIPCookie' + '=([^;]+)')[1];
	// Capture values of key/val pair
	region = region.split('=');

	// If cookie has no countryCode, return undefined
	if (region.length <= 1) {
		return;
	}

	// Return countryCode from key/val
	return region[1];
}

export function isVisitorInEU() {
	return !!(EU_COUNTRY_CODES.indexOf(getGeoIPCountryCode()) > -1);
}

/**
 * Checks the GeoIPCookie cookie to determine if the visitor is in China
 * @return {boolean}          True if the visitor is in China
 */
export const isVisitorInChina = () => !!(getGeoIPCountryCode() === 'CN');

/**
 * Returns the value for a given cookie name
 * @param  {String} [name='']   The name of the cookie
 * @return {String|undefined}   The value of the given cookie name or undefined if not found
 */
export function getCookieValue(name = '') {
	const start = document.cookie.indexOf(`${name}=`);
	const end = document.cookie.indexOf(';', start);
	const cookie = document.cookie.slice(start, end > -1 ? end : document.cookie.length);
	return cookie.split('=')[1];
}

/**
 * Sets thee value for a cookie
 * @param {String} name        	    Name of the cookie
 * @param {String} value            Value for the cookie
 * @param {[type]} expirationDate   Expiration date for the cookie
 * @param {String} [path='/']       Path to use in the cookie
 */
export function setCookie(name, value, expirationDate, path = '/') {
	const expirationString = expirationDate
		? `; expires=${new Date(expirationDate).toUTCString()}`
		: '';
	document.cookie = `${name}=${value}${expirationString}; path=${path}`;
}

/**
 * Triggers a custom event on resize when width
 * was changed
 */
export const horizontalResizeEvent = 'onwidthresize';
export const onWidthResize = () => {
	let cachedWidth = $(window).width();

	$(window).on('resize', () => {
		const newWidth = $(window).width();

		if (newWidth !== cachedWidth) {
			cachedWidth = newWidth;
			$(document).trigger(horizontalResizeEvent);
		}
	});
};
if (screen && screen.orientation && screen.orientation.addEventListener) {
	screen.orientation.addEventListener('change', () => {
		$(document).trigger(horizontalResizeEvent);
	});
} else {
	window.addEventListener('orientationchange', () => {
		$(document).trigger(horizontalResizeEvent);
	});
}

/**
 * Tab index helper
 */
export const tabIndexManager = {
	/**
	 * Restore an element previous tabindex if it was set prior
	 * call to method tabIndexManager.disable
	 *
	 * @param {String} elements  DOM elements
	 */
	reinstate: (elements, keepData) => {
		$(elements).each((_, item) => {
			const $item = $(item);

			if ($item.data('tabindex') !== undefined) {
				$item.attr('tabindex', $item.data('tabindex'));
				if (!keepData) {
					$item.removeAttr('data-tabindex');
				}
			} else {
				$item.removeAttr('tabindex');
			}
		});
	},
	/**
	 * Disable an element by setting its tabindex to -1.
	 * Saves initial value, this will be reinstated later
	 *
	 * @param {String} elements  DOM elements
	 */
	disable: (elements, tabindex) => {
		tabindex = tabindex !== undefined ? tabindex : -1;
		$(elements).each((_, item) => {
			const $item = $(item);

			if (item.hasAttribute('tabindex')) {
				$item.attr('data-tabindex', $item.attr('tabindex'));
			}

			$item.attr('tabindex', tabindex);
		});
	},
};

/**
 * Returns the index of the previous item in a cyclic array
 * @param  {Array} 	array   The array to process
 * @param  {Number} current The current index
 * @return {Number}         The calculated index
 */
export function getPrevArrayIndex(array, current) {
	if (current - 1 < 0) {
		return array.length - 1;
	} else {
		return current - 1;
	}
}

/**
 * Returns the index of the next item in a cyclic array
 * @param  {Array} 	array   The array to process
 * @param  {Number} current The current index
 * @return {Number}         The calculated index
 */
export function getNextArrayIndex(array, current) {
	if (current + 1 >= array.length) {
		return 0;
	} else {
		return current + 1;
	}
}

/**
 * Returns true if at least one element of one array is included in another array.
 * False otherwise.
 * @param {Array} searchArr The search array whose elements are going to be checked in
 * the second array
 * @param {Array} arr The array against the search array is going to be checked
 * @returns {Boolean} True if there is at least one element included in the array.
 * False otherwise
 */
export function findOne(searchArr, arr) {
	return arr.some(e => searchArr.indexOf(e) >= 0);
}

/**
 * Returns true if the given element is inside the viewport within an offset
 * @param  {Element}  element          The HTML element to test
 * @param  {Number}  [offsetDelta=0]   The number of pixels for the offset difference
 * @return {Boolean}                   True if the element is inside the viewport + offset. False otherwise
 */
export function isElementInView(element, offsetDelta = 0) {
	const $element = $(element);
	const screenTop = $(window).scrollTop();
	const screenBottom = screenTop + $(window).height();
	const offsetTop = $element.offset().top;
	const computedOffsetTop = offsetTop - offsetDelta;
	const computedOffsetBottom = offsetTop + $element.outerHeight() + offsetDelta;
	return !!(screenBottom > computedOffsetTop && screenTop < computedOffsetBottom);
}

export function isKeyEvent(event) {
	const x = event.x > 0 || event.clientX > 0;
	const y = event.y > 0 || event.clientY > 0;

	return !x && !y;
}

export function getQueryFromString(string = '', options = {}) {
	const pairs = string.replace('#', '').split(options.delimiter || '&');
	return pairs.reduce((result, pair) => {
		//using indexOf to handle the value itself having a '=' in it
		let splitIndex = pair.indexOf('=');
		let [key, value] = splitIndex
			? [pair.substring(0, splitIndex), pair.substring(splitIndex + 1)]
			: pair.split('=');
		if (key) {
			if (options.keysToLowerCase) {
				key = key.toLowerCase();
			}

			if (options.commaArrays === true) {
				value = value.indexOf(',') > 0 ? value.split(',') : value;
			}

			if (options.duplicates === true) {
				value = value ? [value] : [];
				value = result[key] ? result[key].concat(value) : value;
			}

			result[key] = value || '';
		}
		return result;
	}, {});
}

export function getStringFromQuery(object = {}, options = {}) {
	const pairs = Object.keys(object).reduce((pairs, key) => {
		pairs.push(`${key}=${object[key]}`);
		return pairs;
	}, []);
	return pairs.join(options.delimiter || '&');
}

export function isEmail(email) {
	// Regex from http://emailregex.com/
	const emailRegEx =
		/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return emailRegEx.test(email);
}

export function getLang() {
	return $('html').attr('lang') || 'en';
}

export function normalizeString(string) {
	// Remove accents https://stackoverflow.com/a/37511463
	return string
		?.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.toLowerCase();
}

/**
 * Removes the hash in the URL
 */
export function removeHash() {
	history.replaceState('', document.title, window.location.pathname + window.location.search);
}

/**
 * get hash property from the URL
 */
let cachedQueryHash = '';

export function getHashProperty() {
	if (
		window.location.hash.length <= 0 &&
		(window.location.search.indexOf('query-hash') > -1 || cachedQueryHash)
	) {
		//return getQueryFromString(window.location.search.replace('?', ''))['query-hash'];

		if (cachedQueryHash) {
			return cachedQueryHash;
		}

		const queryParams = getQueryFromString(
			window.location.search ? window.location.search.substring(1) : ''
		);
		if (queryParams['query-hash']) {
			cachedQueryHash = queryParams['query-hash'];
			delete queryParams['query-hash'];
			let queryString = getStringFromQuery(queryParams);
			queryString = queryString ? '?' + queryString : '';
			const newUrl = `${window.location.origin}${window.location.pathname}${queryString}#${cachedQueryHash}`;
			history.replaceState('', document.title, newUrl);

			return cachedQueryHash;
		}
	} else {
		return window.location.hash.replace('#', '').split('#')[0];
	}
}

/**
 * get indexed hash property from the URL
 */
export function getIndexedHashProperty() {
	let indexedHash = null;
	const hashValue = decodeURIComponent(getHashProperty() || '');
	if (hashValue) {
		if (hashValue.indexOf('||') > -1) {
			const splitHash = hashValue.split('||');
			let idx = 1;
			try {
				idx = parseInt(splitHash[1], 10);
			} catch (e) {
				//empty by design
			}

			indexedHash = { id: splitHash[0], index: idx };
		} else {
			indexedHash = { id: hashValue, index: 1 };
		}

		//verify that the id is actually a valid selector
		try {
			$(`#${indexedHash.id}`);
		} catch {
			// invalid, just return null
			indexedHash = null;
		}
	}
	return indexedHash;
}

/**
 * Sanitices strings by removing spaces
 * and processing potentially non compatible characters
 *
 * @param {String} text
 * @returns {String} sanitized text
 */
export function sanitizeText(text) {
	return normalizeString(text)
		.trim()
		.replace(/[,-]/g, '')
		.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}

export const romanLangs = ['en', 'fr', 'es', 'de', 'br'];

/**
 * Set the skip link for the given element
 * @param {jquery} $element The element to set the skip link
 */
export const setSkipLink = $element => {
	const skipLinkCssClass = '.SkipLink-link';
	const $skipMapLink = $element.find(skipLinkCssClass);

	// Find the next element. If not found (eg. this is the last item ), take the
	// next sibling of the parent
	let $upperParent = $element;
	let $skipMapTarget = $element.next();
	while ($skipMapTarget.length === 0 && $upperParent[0].nodeName !== 'BODY') {
		$upperParent = $upperParent.parent();
		$skipMapTarget = $upperParent.next();
	}

	$skipMapLink.on('click', e => {
		$skipMapTarget.attr('tabindex', -1);
		e.preventDefault();
		$skipMapTarget.focus();
	});
};

/**
 *
 * Takes an encrypted string and return promise resolving to the value
 * @param {string} encryptedStr
 * @return {Promise} Resolves to value of decrypted string or rejects if error occurs
 */
export const decrypt = encryptedStr => {
	return new Promise((resolve, reject) => {
		$.get('/alt/apps/fshr/global/decrypt.json', { encrypted: encryptedStr }, (data, status) => {
			if (data && data.decrypted) {
				resolve(data.decrypted);
			} else {
				reject(data);
			}
		});
	});
};

export /**
 *
 * Takes an encrypted email and return promise resolving to the email or rejects on error or if not an email
 * @param {string} encryptedEmail
 * @returns {Promise}
 */
const decryptEmail = encryptedEmail => {
	return new Promise((resolve, reject) => {
		decrypt(encryptedEmail)
			.then(decryptedEmail => {
				if (isEmail(decryptedEmail)) {
					resolve(decryptedEmail);
				} else {
					reject(decryptEmail);
				}
			})
			.catch(result => {
				reject(result);
			});
	});
};

export const isMobileBrowser = () => {
	const a = navigator.userAgent || navigator.vendor || window.opera;
	if (
		/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
			a
		) ||
		/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
			a.substr(0, 4)
		)
	) {
		return true;
	}
	return false;
};

let allowLock = false;
let prevLock = false;
// modern Chrome requires { passive: false } when adding event
let supportsPassive = false;
try {
	window.addEventListener(
		'test',
		null,
		Object.defineProperty({}, 'passive', {
			get: function () {
				supportsPassive = true;
			},
		})
	);
} catch (e) {
	//empty by design
}
const wheelOpt = supportsPassive ? { passive: false, capture: true } : false;
const wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';
// for accessibility we don't want to allow locking if they never use any traditional scroll events, for users that only use kb or scroll bar, etc
window.addEventListener('DOMMouseScroll', () => (allowLock = true), false); // older FF
window.addEventListener(wheelEvent, () => (allowLock = true), wheelOpt); // modern desktop
window.addEventListener('touchmove', () => (allowLock = true), wheelOpt); // mobile
window.addEventListener('blockLock', () => {
	prevLock = allowLock;
	allowLock = false;
});
window.addEventListener('allowLock', () => (allowLock = prevLock));
export const unlockScroll = () => {
	//make everything scrollable and normal width rules
	$(document.body).css({
		overflow: '',
		'max-width': '',
		width: '',
		'margin-right': '',
	});
	$(`nav`).css({
		'max-width': '',
		width: '',
	});
};
let scrollBarWidth = 0;
export const lockScroll = force => {
	if (allowLock || force) {
		unlockScroll();
		const width = document.body.scrollWidth;
		//overflow hidden is the only way to disable browser scrolling
		$(document.body).css('overflow', 'hidden');
		const newWidth = document.body.scrollWidth;
		//get scroll bar width so we know how to fix fixed pagination
		scrollBarWidth = newWidth - width;
		//fix so the scrollbar disappearing doesn't cause page movement
		$(document.body).css({
			'max-width': `${width}px`,
			width: `${width}px`,
		});
		if (getRTL()) {
			$(document.body).css({
				'margin-right': `${scrollBarWidth}px`,
			});
		}

		//fixed with nav needs to be same width as body
		$(`nav`).css({
			'max-width': `${width}px`,
			width: `${width}px`,
		});
	}
	return allowLock || force;
};
export const isScrollLockAllowed = () => {
	return allowLock;
};

export const onLoadComplete = callback => {
	if (callback && typeof callback === 'function') {
		if (document.readyState === 'complete') {
			callback();
		} else {
			window.addEventListener('load', () => {
				callback();
			});
		}
	} else {
		console.error('onLoadComplete requires a callback function');
	}
};

export const initializeSvelte = (componentName, svelteComponent) => {
	for (let placeholder of document.querySelectorAll(`.${componentName}-ssr-placeholder`)) {
		new svelteComponent({
			target: placeholder,
			props: placeholder.dataset.props || placeholder.dataset,
		});
	}
};

// Server-side still uses momentjs so convert the formats
export const convertMomentFormat = momentFormat => {
	return momentFormat.replaceAll('DD', 'dd').replaceAll('YY', 'yy');
};

export async function importGoogleMaps(key) {
	(g => {
		var h,
			a,
			k,
			p = 'The Google Maps JavaScript API',
			c = 'google',
			l = 'importLibrary',
			q = '__ib__',
			m = document,
			b = window;
		b = b[c] || (b[c] = {});
		var d = b.maps || (b.maps = {}),
			r = new Set(),
			e = new URLSearchParams(),
			u = () =>
				h ||
				(h = new Promise(async (f, n) => {
					await (a = m.createElement('script'));
					e.set('libraries', [...r] + '');
					for (k in g)
						e.set(
							k.replace(/[A-Z]/g, t => '_' + t[0].toLowerCase()),
							g[k]
						);
					e.set('callback', c + '.maps.' + q);
					e.set('loading', 'async');
					a.src = `https://maps.${c}apis.com/maps/api/js?` + e;
					d[q] = f;
					a.onerror = () => (h = n(Error(p + ' could not load.')));
					a.nonce = m.querySelector('script[nonce]')?.nonce || '';
					a.async = true;
					m.head.append(a);
				}));
		d[l]
			? console.warn(p + ' only loads once. Ignoring:', g)
			: (d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n)));
	})({
		key: key,
		v: 'weekly',
		// Use the 'v' parameter to indicate the version to use (weekly, beta, alpha, etc.).
		// Add other bootstrap parameters as needed, using camel case.
		region: getGeoIPCountryCode(),
		language: getLang(),
	});

	const { Map } = await google.maps.importLibrary('maps');
	return Map;
}
